export default __webpack_public_path__ + "locales/az/DeleteThirdPartyDialog.json?hash=ffa446cb89a7915b8860d7823d11fe39";